module.exports = __webpack_public_path__ + "static/media/02(3).7cef4296.jpg";